import * as Types from "../../../constants";
import produce from "immer";

let initialState = {
  dataMerch: [],
  totalMerch: [],
  merchDetail: {},
  total: 0
};
export default (state = initialState, action = {}) => {
  return produce(state, draft => {
    switch (action.type) {
      case Types.GET_LIST_DATA_MERCH:
        draft.dataMerch = action.payload.data;
        draft.total = action.payload.total;
        break;
      case Types.GET_TOTAL_DATA_MERCH:
        draft.totalMerch = action.total_data;
        break;
      case Types.GET_MERCH_DETAIL:
          draft.merchDetail = action.detail_merch;
          break;
      default:
        return state;
    }
  })
}

